export const initialState = {
	colors: [],
	loading: false,
	error: '',
};